// extracted by mini-css-extract-plugin
export default {"table":"webpack-concepts-Extraction-Blocks-Table-control-TableComparisonRow-module__table"};